import React, { useState } from 'react';
import { CollateralBaseUrl } from '../../../utils/BaseUrl';
import { connect } from 'react-redux';

function CollateralImageListing(props) {

  // const { CurrentRole } = props;

  const [seeMore, setSeeMore] = useState(false)

  if (props.collateral.length < 1) return <></>;


  return (
    
    <>
    {props.collateral.map((r, k) => {
      if(k < 3 || seeMore){
        return (
          <div
            key={k}
            className="col-12 col-sm-12 mb-3 p-2 bg-purple under-review multi-shot position-relative collateralImageListing"
            style={{
              backgroundImage: `url('${CollateralBaseUrl + r.image}')`,
              backgroundSize: 'cover',
            }}
          >
            <h3 className="font-16 text-white font-weight-700 m-0 p-2 position-relative">
              {r.collateral_name}
            </h3>
            {r.status === 0 ? (
              <div>
                <div className="collateral_underReview">
                  <i className="fas fa-search dropdown_icon"></i>
                  <div className="collateral_message">
                    Collateral Under Review
                  </div>
                </div> 
              </div> 
            ) : (
              null
            )}
            {r.status === 4 ? (
              <div>
                <div className="collateral_underReview">
                  <i className="fas fa-search dropdown_icon"></i>
                  <div className="collateral_message">
                  Requested For Deletion
                  </div>
                </div> 
              </div> 
            ) : (
              null
            )}
          </div>
        );
      } else return null
  })}
    {/* { props.collateral.length > 3 ? <p className="text-primary cursor-pointer" onClick={() => setSeeMore(!seeMore)}>See {seeMore ? 'less' : 'more'}</p> : null} */}
     <div  className={`w-100 d-flex align-items-center mt-2 ${props.publicView === true ? 'justify-content-center' : 'justify-content-between'}`}>
      {props.publicView === true ? 
        null :
      <a href="/"
        onClick={(e) =>{
          props.OpenPopup('Collateral');e.preventDefault()}
        }
        className="font-12 font-weight-600 text-primary cursor-pointer" 
      >
        <i className="fas fa-plus mr-1"></i> Add Collateral
      </a>}
      {props.collateral.length > 3 ?
      <p onClick={() => setSeeMore(!seeMore)} className="view-more mb-0">
        <span className="font-12 text-primary font-weight-600 p-1 bg-white" id=""> See {seeMore ? 'less' : 'more'} 
        <i className={`fas ml-1 fa-chevron-${seeMore ? 'up' : 'down'}`}></i></span>
      </p> : null}
      </div> 
    </>
  )

}

const mapDispatch = dispatch => ({
  OpenPopup: (text) =>
  dispatch({ type: 'OPEN_POPUP_SAGA', payload: { Component: text } }),
})

const mapState = state => {
  const Me = state.globalReducer.Me
  const creatorProfile = state.creatorProfile
  return({
    CurrentRole: Me.CurrentRole,
    publicView: creatorProfile.public,

  })
}

export default connect(mapState, mapDispatch)(CollateralImageListing)
